import 'tooltipster'

export default {
    graphicInteractive() {
        $('.tooltip').tooltipster({
            contentCloning: true,
            interactive: true,
        })
        $('.tooltip-mobile').tooltipster({
            // contentCloning: true,
            interactive: true,
            trigger: 'click',
        })
        $(document.body).on('click','.tooltip, .tooltip-mobile', function(e){
            e.preventDefault()
        })
    },
    init(){
        this.graphicInteractive()
    },
};
